<template>
  <div class="relative bg-cyan-600 w-full rounded-xl px-6 py-6 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden min-h-[120px]" style="background-color:#0891b2;">
    <div class="absolute top-4 right-4 opacity-20">
      <font-awesome-icon icon="fa-solid fa-dollar" class="text-white" style="font-size: 48px;" />
    </div>
    <div class="relative z-10 pr-20">
      <div class="text-white text-xs font-semibold uppercase tracking-wide mb-2">Cuentas por Cobrar</div>
      <div class="text-white text-4xl font-bold mb-1">{{ money }}{{ total }}</div>
      <div class="text-white/90 text-xs font-medium">Hoy {{ date }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TotalAccountsReceivable",
  props: {
    total: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    money: {
      type: String,
      required: true,
    },
  },
};
</script>
